import React from 'react';
import '../style//about.css';
import '../style//general.css';
import '../style//queries.css';
import logo from '../img/logo.png';

const About = () => {
  return (
    <div>
        
        <div className="about-description">
        <h2><b>IJESACBT</b></h2>
        The " International Journal of Engineering Science, Advanced Computing and Bio-Technology (IJESACBT) " is an international 
        online journal in English published quarterly. The aim of IJESACBT is to publish peer reviewed research and review articles, 
        faster without delay (within 2-3 week) in the developing field of engineering science, computing and bio-technology.
        </div>

        <div className="about-description">
            <h2><b>Aim and Scope:</b></h2>
            IJESACBT would take much care in making your article published without much delay with your kind cooperation. <br />
            IJESACBT hopes that Researchers, Research scholars, Academician, Industrialists etc. would make use of this journal 
            publication for the development of science and technology.

        </div>

        <div className="about-description">
            <h2><b>Journal Policy</b></h2>
            IJESACBT provides an international forum for the electronic publication of high-quality scholarly articles in all areas of Engineering, 
            Science, Advanced Computing and Bio-Technology. All research articles submitted to IJESACBT should be original in nature, never previously 
            published in any journal or presented in a conference or undergoing such process across the globe. All the submissions will be 
            peer-reviewed by the panel of experts associated with particular field. Submitted papers should meet the internationally accepted 
            criteria and manuscripts should follow the style of the journal for the purpose of both reviewing and editing.
        </div>

        <h3 className='about-description'> <b>Editor-In-Chief(s):</b></h3>
        <div className="editor-wrapper">
            <div className="editor-token">
                <h4><i><b>Dr. R. Ponalagusamy</b></i></h4> 
                Department of Mathematics, National Institute of Technology, Trichy, India.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. T.N. Janakiraman</b></i></h4> 
                Department of Mathematics, National Institute of Technology, Trichy, India.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. P.J.A. Alphonse</b></i></h4> 
                Department of Computer Applications, National Institute of Technology, Trichy, India.
            </div>
        </div>

        <h3 className='about-description'> <b>Editorial Board:</b></h3>
        <div className="editor-wrapper">
            <div className="editor-token">
                <h4><i><b>Dr. Mutsuto Kawahara</b></i></h4> 
                Department of Civil Engineering, Chuo University, Tokyo, Japan.
            </div>
            <div className="editor-token">
                <h4><i><b>Bishun D.Pandey</b></i></h4> 
                Department of Mathematics, OHIO STATE university, Marion, USA.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. B.M. Mohan</b></i></h4> 
                Department of Computer Science, University of Manitoba, Winnipeg, Canada.
            </div>
            <div className="editor-token">
                <h4><i><b>Ruppa K. Thulasiram</b></i></h4> 
                Department of Computer Science, University of Manitoba, Winnipeg, Canada.
            </div>
        
            <div className="editor-token">
                <h4><i><b>Hideki Sano</b></i></h4> 
                Department of Applied Mathematics, Graduate School of System Informatics,Kobe University, Japan
            </div>
            <div className="editor-token">
                <h4><i><b>Prof.Dr. Necdet BİLDİK</b></i></h4> 
                Department of Mathematics, Celal Bayar University, Manisa / TURKEY
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. R. Narayanasamy</b></i></h4> 
                Department of Production Engineering, National Institute of Technology, Trichy, India.
            </div>
            <div className="editor-token">
                <h4><i><b>Prof. A. Sapounakis </b></i></h4> 
                Department of Informatics, University of Piraeus, GREECE.
            </div>
       
            <div className="editor-token">
                <h4><i><b>Dr. khaled Mekheimer</b></i></h4> 
                Mathematics Department, Al-Azhar University, Nasr City (11884), Cairo, Egypt.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr.A.Kannan</b></i></h4> 
                Department of Information Science and Technology,Anna University, Chennai, India.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. Md Mahabubur Rahman TALUKDER</b></i></h4> 
                Scientist II, a* Institute of Chemical and Engineering Sciences, Jurong Island, Singapore.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. Madhumangal Pal</b></i></h4> 
                Department of Applied Mathematics, Vidyasagar University,West Bengal, India.
            </div>
       
            <div className="editor-token">
                <h4><i><b>Dr. Gour Chandra Paul </b></i></h4> 
                Department of Mathematics, Rajshahi University, Bangladesh.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. Alak Datta</b></i></h4> 
                Department of Computer Science, Biswabharati University, West Bengal, India.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. P. Syam Kumar</b></i></h4> 
                Institute for Development and Research in Banking Technology (IDRBT), Hyderabad, India

            </div>
            <div className="editor-token">
                <h4><i><b>Dr. B. Gayathri</b></i></h4> 
                Department of Mathematics, Periyar E. V. R. Govt. College, India.
            </div>
       
            <div className="editor-token">
                <h4><i><b>Dr. P.J.A. Alphonse </b></i></h4> 
                Department of Computer Applications, National Institute of Technology, Trichy, India.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. N. Ramesh Babu</b></i></h4> 
                Metallurgical and Materials Engineering, National Institute of Technology, Trichy, India.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. G.Saravana Ilango</b></i></h4> 
                Electrical and Electronics Engineering, National Institute of Technology, Trichy, India.
            </div>
            <div className="editor-token">
                <h4><i><b>Dr. R.Eswari</b></i></h4> 
                Department of Computer Applications, National Institute of Technology, Trichy, India
            </div>
       
            <div className="editor-token">
                <h4><i><b>Dr. V. Anandakrishnan </b></i></h4> 
                Department of Production Engineering, National Institute of Technology, Trichy, India
            </div>
        </div>

       

       
        <div className="about-description">
            <h2><b>CopyRight Claim:</b></h2>
            Any claims of copyright infringement should be addressed to the Editor bearing the subject line <b>"Copyright Infringement"</b>. <br /><br />
            The claim must be sufficed by documented evidence supporting the same version as being published or copyrighted or 
            patented by the aggrieved party before the date of publication of the concerned IJESACBT article. On receipt of the claim, 
            the IJESACBT Editorial Board, if found deemed, shall inform the IJESACBT author to provide an explanation; the discussion of which 
            shall be transparent to both parties. The IJESACBT Board reserves the sole rights to decide the validity of any such claims. 
            After deliberation, if the claim is found justified, the concerned manuscript will be removed from all IJESACBT archives and servers. In case, 
            the changes required are minimal such as inclusion of references, the authors will be intimated to do the required amendments. The alternative 
            version shall undergo peer-review as any other general submission and shall be published in the same issue(number) of the concerned volume. 
            <br /><br />
            Any claims on copyright will be addressed with the highest priority. A revert mail will be dispatched within 3 working days provided the claim 
            is supported with documented evidence.


        </div>
        
    </div>
  );
}

export default About;

